import { useEffect, useState } from "react";
import api from "../lib/api";
import { ChevronDown, Search } from "lucide-react";

export default function FAQ() {
  const [faqs, setFaqs] = useState([]);
  const [openIdx, setOpenIdx] = useState(null);
  const [q, setQ] = useState("");
  const [cat, setCat] = useState("");

  useEffect(() => { api.get("/faqs").then(r => setFaqs(r.data)).catch(()=>{}); }, []);

  const cats = ["", ...Array.from(new Set(faqs.map(f => f.category)))];
  const filtered = faqs.filter(f =>
    (!cat || f.category === cat) &&
    (!q || (f.q + f.a).toLowerCase().includes(q.toLowerCase()))
  );

  return (
    <div className="max-w-5xl mx-auto px-5 md:px-10 py-16" data-testid="faq-page">
      <span className="brut-tag pink">Help center</span>
      <h1 className="font-display font-black text-5xl md:text-7xl mt-3 tracking-tighter">FAQs.</h1>
      <p className="mt-3 text-lg text-[#4A4A4A]">Answers to the things students &amp; owners ask us most.</p>

      <div className="brut-card p-3 mt-8 flex items-center gap-2" data-testid="faq-search">
        <Search size={18} className="ml-2"/>
        <input className="flex-1 bg-transparent py-3 outline-none font-medium" placeholder="Search FAQs..." value={q} onChange={e=>setQ(e.target.value)} data-testid="faq-search-input"/>
      </div>

      <div className="flex flex-wrap gap-2 mt-5">
        {cats.map(c => (
          <button key={c||"all"} onClick={()=>setCat(c)} className={`brut-tag ${cat===c?"lime":"white"} cursor-pointer`} data-testid={`faq-cat-${c||"all"}`}>{c||"All"}</button>
        ))}
      </div>

      <div className="space-y-3 mt-8">
        {filtered.length === 0 && <div className="brut-card p-8 text-center text-[#4A4A4A]">No FAQs match your search.</div>}
        {filtered.map((f, i) => (
          <div key={i} className="brut-card overflow-hidden" data-testid={`faq-item-${i}`}>
            <button onClick={()=>setOpenIdx(openIdx===i?null:i)} className="w-full text-left p-5 flex justify-between items-center hover:bg-[#ECFAF1]">
              <div>
                <span className="brut-tag white !mr-3">{f.category}</span>
                <span className="font-bold">{f.q}</span>
              </div>
              <ChevronDown className={`transition-transform ${openIdx===i?"rotate-180":""}`} size={20}/>
            </button>
            {openIdx === i && <div className="p-5 pt-0 text-[#2a2a2a]">{f.a}</div>}
          </div>
        ))}
      </div>
    </div>
  );
}
